/**
 * Where a slider thumb sits on its track. Shared so an overlay that must line up
 * with a thumb — the ShowPath replay playhead — cannot desync from it.
 */

const THUMB_WIDTH_PX = 27;

/** Between the track edge and the thumb at either extreme. */
const TRACK_PADDING_PX = 2.5;

/** How much narrower the thumb's travel is than the track. */
export const SLIDER_TRACK_INSET_PX = THUMB_WIDTH_PX + TRACK_PADDING_PX * 2;

export const SLIDER_THUMB_EDGE_OFFSET_PX = TRACK_PADDING_PX;

export const SLIDER_THUMB_CENTER_OFFSET_PX =
  TRACK_PADDING_PX + THUMB_WIDTH_PX / 2;

/** CSS `left` for the thumb's LEFT EDGE at `fraction` (0–1, or a CSS expression). */
export function sliderThumbEdgeLeft(fraction: number | string): string {
  return `calc(${SLIDER_THUMB_EDGE_OFFSET_PX}px + (100% - ${SLIDER_TRACK_INSET_PX}px) * ${fraction})`;
}

/** CSS `left` for the thumb's CENTRE. Pair with `translateX(-50%)`. */
export function sliderThumbCenterLeft(fraction: number | string): string {
  return `calc(${SLIDER_THUMB_CENTER_OFFSET_PX}px + (100% - ${SLIDER_TRACK_INSET_PX}px) * ${fraction})`;
}

/** CSS `right` for the thumb's CENTRE, for spans anchored from the right. */
export function sliderThumbCenterRight(fraction: number | string): string {
  return `calc(100% - ${SLIDER_THUMB_CENTER_OFFSET_PX}px - (100% - ${SLIDER_TRACK_INSET_PX}px) * ${fraction})`;
}
